/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { BUDGET_QUESTION } from "../graphQL/queries";
import { useQuery } from "@apollo/client";
import classes from './budget.module.scss'
import cx from "classnames";


const Budget = (props: any) => {
    const { node, data, change } = props;
    const { data: budget } = useQuery(BUDGET_QUESTION, {
        variables: { key: { allofterms: "tripBudget" } },
    });

    const setChange = (value: any) => {
        let updateData = [...data];
        let filter: any;
        filter = updateData.filter((n: any) => {
            return n.name === node.name;
        });
        if (filter[0]) {
            filter[0].value = value
        }
        change([...updateData])

    }
    useEffect(() => {
        let updateData = [...data];
        let filter: any;
        filter = updateData.filter((n: any) => {
            return n.name === node.name;
        });
        if (filter[0]) {
            filter[0].value = budget?.queryTravelQuestion[0]?.defaultValue
        }
        change([...updateData])
    }, [node, budget])
    return <div className={classes.textGroup}>
        <div className={classes.textdesign}>{node.title}</div>
        <div className={classes.textfield}>
            {(budget?.queryTravelQuestion[0]?.answerChoices)?.slice().sort((a: any, b: any) => a.sortOrder - b.sortOrder).map((key: any, n: any) => {
                return <span title={key.tooltip} onClick={() => setChange(key.value)} key={n} className={node.value ? (node.value === key.value) ? cx(classes.options, classes.selected) : classes.options : classes.options}>
                    {key.value}
                </span>;
            })}
        </div>
    </div>

}
export default Budget